import apiCall from "../AuthorizedApi";
import { showErrorToast } from "../../../components/atoms/Utlis/Toast";
import type { UserAnalyticsResponse } from "../../../Data/analytics.dto";

export type AnalyticsPeriod = "this_year" | "last_year" | "custom";

export interface UserAnalyticsParams {
  period?: AnalyticsPeriod;
  start_date?: string; // YYYY-MM-DD, required if period=custom
  end_date?: string;   // YYYY-MM-DD, required if period=custom
}

function buildAnalyticsQueryString(params: UserAnalyticsParams): string {
  const search = new URLSearchParams();
  const period = params.period ?? "this_year";
  search.set("period", period);
  if (period === "custom") {
    if (params.start_date) search.set("start_date", params.start_date);
    if (params.end_date) search.set("end_date", params.end_date);
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

/**
 * GET /project/user/analytics/
 * Fetches user analytics for the given period.
 * Query params: period (this_year | last_year | custom), start_date & end_date when period=custom.
 */
export async function getUserAnalyticsAPI(
  params: UserAnalyticsParams = {}
): Promise<UserAnalyticsResponse> {
  try {
    const query = buildAnalyticsQueryString(params);
    const response = await apiCall({
      method: "GET",
      url: `/project/user/analytics/${query}`,
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = (response as { data?: UserAnalyticsResponse["data"] })?.data ?? response;
    return { data: data as UserAnalyticsResponse["data"] };
  } catch (error: unknown) {
    const err = error as { response?: { data?: { message?: string; detail?: string } } };
    const message =
      err?.response?.data?.message ||
      err?.response?.data?.detail ||
      "Failed to load analytics.";
    showErrorToast(message);
    throw error;
  }
}
